import { NgModule } from "@angular/core";
import {
  mapToCanActivate,
  PreloadAllModules,
  RouterModule,
  Routes,
} from "@angular/router";

import { RoutingPath } from "@core/enums/routing-path";
import { AuthGuard } from "@core/guards/auth.guard";

const routes: Routes = [
  {
    path: RoutingPath.Login,
    loadChildren: (): any =>
      import("./views/login/login-routes").then((m) => m.routes),
  },
  {
    path: "",
    loadChildren: (): any =>
      import("./views/wrapper-routes").then((m) => m.routes),
    canActivate: mapToCanActivate([AuthGuard]),
  },
  {
    path: "**",
    redirectTo: RoutingPath.NotFound,
    pathMatch: "full",
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
